/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  id: string;
}>;

export const DeleteRoleTitle = async (option: Option) => {
  const $uuid = <Variable name="id" scalar={<UuidScalar />} value={option.id} />;
  const { query, variables } = render(
    <Mutation operationName="DELETE_ROLE_TITLE">
      <SelectionSet
        name="deleteRole_title"
        alias="deleteRoleTitle"
        argument={{
          where: {
            id: $uuid
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deleteRoleTitle: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.role.request<Data>(query, variables);
};
